import { render } from "./PendingPrs.vue?vue&type=template&id=2f6e75b2"
import script from "./PendingPrs.vue?vue&type=script&lang=js"
export * from "./PendingPrs.vue?vue&type=script&lang=js"

import "./PendingPrs.vue?vue&type=style&index=0&id=2f6e75b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__